/**
 * @generated SignedSource<<7a9fa5a951f77e1ab37e6b498146c8d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiagnosticProjectedStatus = "AHEAD" | "AT_RISK" | "ON_TRACK" | "%future added value";
export type ClassDiagnosticReportFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  roadmapId: string;
};
export type DiagnosticsGetStudentsTableQuery$variables = {
  input: ClassDiagnosticReportFilterInput;
};
export type DiagnosticsGetStudentsTableQuery$data = {
  readonly classDiagnosticReport: ReadonlyArray<{
    readonly demonstratedSkills: number | null | undefined;
    readonly diagnosticCompleted: boolean;
    readonly diagnosticDate: any | null | undefined;
    readonly lastDiagnosticId: number | null | undefined;
    readonly projectedStatusThreeSkills: DiagnosticProjectedStatus | null | undefined;
    readonly projectedStatusTwoSkills: DiagnosticProjectedStatus | null | undefined;
    readonly retakeAssigned: boolean;
    readonly roadmapSkills: number | null | undefined;
    readonly student: {
      readonly firstName: string | null | undefined;
      readonly fullName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    };
  }>;
};
export type DiagnosticsGetStudentsTableQuery = {
  response: DiagnosticsGetStudentsTableQuery$data;
  variables: DiagnosticsGetStudentsTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "input"
      }
    ],
    "concreteType": "ClassDiagnosticReport",
    "kind": "LinkedField",
    "name": "classDiagnosticReport",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demonstratedSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosticCompleted",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosticDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedStatusThreeSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectedStatusTwoSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roadmapSkills",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastDiagnosticId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "retakeAssigned",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "student",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsGetStudentsTableQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticsGetStudentsTableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c683d167497003076f731238ec29dfd",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsGetStudentsTableQuery",
    "operationKind": "query",
    "text": "query DiagnosticsGetStudentsTableQuery(\n  $input: ClassDiagnosticReportFilterInput!\n) {\n  classDiagnosticReport(filter: $input) {\n    demonstratedSkills\n    diagnosticCompleted\n    diagnosticDate\n    projectedStatusThreeSkills\n    projectedStatusTwoSkills\n    roadmapSkills\n    lastDiagnosticId\n    retakeAssigned\n    student {\n      id\n      fullName\n      publicUserId\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e6afea97b330831488c30230cc5a288";

export default node;
